import repository from "../Repository";

export default {
  list(screenId, disasterNo) {
    return repository.post(
      `facility_eva_info`,
      {
        disaster_no: disasterNo,
        is_summary: "true"
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
